import React from 'react';

const LegalPage = () => {
  return (
    <div className="main-content">
      <div className="container">
        <h1>Legal Information</h1>
        
        <div className="legal-content">
          <h2>Operator Details</h2>
          <p><strong>Smart Factory (Kunshan) Co., Ltd.</strong></p>
          <p>German Industrial Park II</p>
          <p>No. 692 Depu Road, Zhangpu Town</p>
          <p>215321 Kunshan, P. R. China</p>
          <p>Phone: +86 512 3685 3980</p>
          <p>Managing Director: Bernd Reitmeier</p>
          
          <h2>Legal Information</h2>
          <p>This website is operated by Smart Factory (Kunshan) Co., Ltd., a company registered in the People's Republic of China.</p>
          
          <p>The content of this website is provided for informational purposes only and does not constitute legal, financial or professional advice.</p>
          
          <p>All rights reserved. No part of this website may be reproduced, distributed, or transmitted in any form or by any means without prior written permission.</p>
          
          <h2>ICP Filing</h2>
          <p>Su ICP Bei No. 18021122-1</p>
          
          <h2>Public Security Filing</h2>
          <p>Su Public Security Bei No. 32058302002589</p>
        </div>
      </div>
    </div>
  );
};

export default LegalPage;